export const sportRegex = {
  teamNameRegex: /^[A-Za-z0-9\s_\-'.'?|()/&]+$/,
  leagueNameRegex: /^[A-Za-z0-9\s_\-'.'?|()/&]+$/,
};
